import image1 from '../images/xiaomi_pad_5_review_thumb800.webp'
import image2 from '../images/apple_ipad_pro_11_inch_2021_review_thumb800.webp'
import image3 from '../images/apple_ipad_pro_13_inch_2021_review19_thumb800.webp'
import image4 from '../images/apple_ipad_mini_2021_review_12_thumb800.webp'
const tablets = [
  { id: '1', image: image1, name: 'Xiaomi Pad 5', price: '531', stars: '5', numberOfReviews: '8' },
  {
    id: '2',
    image: image2,
    name: 'Apple iPad Pro 11in (2021)',
    price: '799',
    stars: '3',
    numberOfReviews: '2'
  },
  {
    id: '3',
    image: image3,
    name: 'Apple iPad Pro 12.9in (2021)',
    price: '1099',
    stars: '2',
    numberOfReviews: '10'
  },
  {
    id: '4',
    image: image4,
    name: 'Apple iPad Mini (2021) ',
    price: '499',
    stars: '4',
    numberOfReviews: '40'
  }
]
export default tablets
